import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/views/Home.vue';
import NotFound from "@/views/NotFound.vue";
// import Announcement from "@/views/Announcement.vue";

// import Intro from "@/views/exam-managememt/Intro.vue";
// import Exam from "@/views/exam-managememt/Exam.vue";
// import ExamResult from "@/views/exam-managememt/ExamResult.vue";
// import Login from "@/views/user-management/Login.vue";


//import CheckUserData from "@/views/user-management/CheckUserData.vue";
//import Register from "@/views/user-management/Register.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        //static
        {
            path: '/',
            redirect: "/Home",
        },
        // Home
        {
            name: "Home",
            path: "/Home",
            component: Home,
        },
        // {
        //     path: 'Announcement',
        //     path: "/Announcement",
        //     component: Announcement,
        // },


        //check User Data
        // {
        //     name: "CheckUserData",
        //     path: "/CheckUserData",
        //     component: CheckUserData,
        // },
        //Register
        // {
        //     name: "Register",
        //     path: "/Register",
        //     component: Register,
        // },
        //Login

        // {
        //     name: "Login",
        //     path: "/Login",
        //     component: Login,
        // },
        // //Intro
        // {
        //     name: "Intro",
        //     path: "/Intro/:token",
        //     component: Intro,
        //     meta: {
        //         requiresAuth: true,
        //     }
        // },
        // //Exam
        // {
        //     name: "Exam",
        //     path: "/Exam",
        //     component: Exam,
        //     meta: {
        //         requiresAuth: true,
        //     }
        // },
        // //Exam Result
        // {
        //     name: "ExamResult",
        //     path: "/ExamResult",
        //     component: ExamResult,
        //     meta: {
        //         requiresAuth: true,
        //     }
        // },

        //not found

        { path: "/:notFound(.*)", component: NotFound },

    ],

    linkActiveClass: "active background-pink",
    scrollBehavior(_, _2, savedPosition) {
        //console.log(to, from, savedPosition);
        if (savedPosition) {
            return savedPosition;
        }
        return { left: 0, top: 0 };
    },

});



export default router;

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        var token = false;
        token = sessionStorage.getItem("access-token");
        //console.log(token);
        if (token === false || token === null) {
            next({
                path: "/login"
            });
        } else {
            next();
        }
    } else {
        next();
    }
});